// extracted by mini-css-extract-plugin
export default {"container":"TempOrganisationManagement_container__34V6m","row":"TempOrganisationManagement_row__zpB9o"};